export default "__VITE_ASSET__1f602dac__"